import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { LocalStorageService } from "ngx-webstorage";
import { secret } from "app/app.env";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { AppLoaderService } from "../app-loader/app-loader.service";
import { PainelService } from "../painel.service";

@Injectable()
export class AuthGuard implements CanActivate {
  public authToken;

  constructor(
    private router: Router,
    private localStorage: LocalStorageService,
    private http: HttpClient,
    private loader: AppLoaderService,
    private painel: PainelService
  ) {}

  validateToken(): Observable<any> {
    return this.painel.validateToken();
  }

  checkAuthenticate(): boolean {
    if (
      this.localStorage.retrieve(secret.userData) !== null &&
      this.localStorage.retrieve(secret.userData).codeCobra !== undefined &&
      this.localStorage.retrieve(secret.parameters) !== undefined
    ) {
      return true;
    } else {
      this.clearLocalStorage();
    }
    return false;
  }

  clearLocalStorage() {
    this.localStorage.clear("contracts");
    this.localStorage.clear(secret.userData);
    this.localStorage.clear(secret.parameters);
    const escritorio = this.localStorage.retrieve(secret.tsDebtor);

    let stringToNavigate =
      typeof escritorio === null ||
      typeof escritorio === undefined ||
      escritorio == null ||
      escritorio == undefined
        ? "/login"
        : "/login/" + escritorio;

    this.router.navigate([stringToNavigate]);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.loader.open("Validando sua sessão");
    this.validateToken().subscribe(
      (d) => this.loader.close(),
      (err) => {
        this.loader.close();
        this.clearLocalStorage();
      }
    );
    return this.checkAuthenticate();
  }
}
